export const moduleName = 'hire-student';